//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";
import pdfvuer from "pdfvuer";
import html2pdf from "html2pdf.js";
import Swal from "sweetalert2";
export default {
  name: "MasterPatent",
  async mounted() {
    this.$showLoader();
    await api.checkVersion();

    // ----------------- Check Authorize ---------------------------
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    if (this.authorize_id == null || this.authorize_id == 0) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
      return; // ป้องกันไม่ให้ทำงานต่อ
    }

    const router_path = parser.pathname.replace("/", "");
    // console.log("router_path:" + router_path);

    try {
      const res_auth = await api.getAuthorize(this.userId, router_path);

      this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
      this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
      this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
      this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

      // ลบบรรทัดนี้ออก - เป็นสาเหตุที่ดีดออกไปหน้าอื่น
      // this.$router.back();

      if (this.userId && api.isLoggedIn()) {
        // OK to continue
      } else {
        this.$store.state.isLogged = false;
        this.$router.push("/login");
        return;
      }

      if (!this.authorize_view) {
        this.$router.push("/not-found");
        return;
      }

      // โหลดข้อมูลหลังจากตรวจสอบ authorize เสร็จแล้ว
      // await this.loaddataPagination();
    } catch (error) {
      console.error("Authorization check failed:", error);
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Error",
        "Failed to check authorization",
        "text-h5 red--text text-center"
      );
    } finally {
      this.$hideLoader();
    }
  },
  components: { SuccessDialog, SuccessDialogPush },
  data(vm) {
    const today = new Date();
    const todayStr = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1
    ).padStart(2, "0")}/${today.getFullYear()}`;

    const plus30 = new Date();
    plus30.setDate(today.getDate() + 30);
    const plus30Str = `${String(plus30.getDate()).padStart(2, "0")}/${String(
      plus30.getMonth() + 1
    ).padStart(2, "0")}/${plus30.getFullYear()}`;

    // แปลง DD/MM/YYYY เป็น YYYY-MM-DD สำหรับ DatePicker
    const toYMD = (ddmmyyyy) => {
      const [dd, mm, yyyy] = ddmmyyyy.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };
    return {
      menuadddatefrom: false,
      searchdatefrom: todayStr,
      searchdatefromPicker: toYMD(todayStr),
      menuadddateto: false,
      searchdateto: plus30Str,
      searchdatetoPicker: toYMD(plus30Str),

      tableLoading: false,
      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      dataupdatestatusmasterpt_id: 0,
      dialogAppoinmentOperationforClosed: false,
      showtimelineData: [],
      dialogtimeline: false,
      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      // itemsPerPage: 100,
      load_bg: false,
      isShowPassword: false,
      fullPage: true,
      search: "",
      mDataArray: [],
      mDataArraypopup: [],
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogShow: false,
      ShowfileNO: "",
      search_pt: "",
      headers: [
        {
          text: "Object Types",
          value: "objecttype_show",
          class: "bg-colorth",
          divider: true,
          width: "130px",
        },
        {
          text: "File No.",
          value: "file_no",
          class: "bg-colorth",
          divider: true,
          width: "105px",
        },
        {
          text: "Application No.",
          value: "app_no",
          class: "bg-colorth",
          divider: true,
          width: "140px",
        },
        {
          text: "Country",
          value: "city",
          class: "bg-colorth",
          divider: true,
          width: "140px",
        },
        {
          text: "Patent No.",
          value: "patent_no",
          class: "bg-colorth",
          divider: true,
          width: "110px",
        },
        // {
        //   text: "Client Ref.",
        //   value: "client_ref",
        //   class: "bg-colorth",
        //   divider: true,
        //   width: "140px",
        // },
        // {
        //   text: "Client Name",
        //   value: "name_of_client",
        //   class: "bg-colorth",
        //   divider: true,
        //   width: "140px",
        // },
        {
          text: "Status",
          value: "status_show",
          class: "bg-colorth",
          divider: true,
          width: "8%",
        },

        {
          text: "Client",
          value: "name_of_client",
          class: "bg-colorth",
          divider: true,
          width: "120px",
        },
        {
          text: "Agent Reference",
          value: "client_ref",
          class: "bg-colorth",
          divider: true,
          width: "140px",
        },
        {
          text: "Agent",
          value: "agent",
          class: "bg-colorth",
          divider: true,
          width: "120px",
        },
        {
          text: "Associate",
          value: "associate",
          class: "bg-colorth",
          divider: true,
          width: "130px",
        },
        {
          text: "Next Annuity Date",
          value: "next_annuity_date",
          class: "bg-colorth",
          divider: true,
          width: "150px",
        },
        {
          text: "Manage",
          value: "actions",
          width: "150px",
          align: "left",
          divider: true,
          sortable: false,
        },
      ],
      headerspopup: [
        {
          text: "Work Type",
          value: "documenttype_code",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "File No.",
          value: "refno",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "Client Name",
          value: "trademark_name",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "Application No.",
          value: "app_no",
          class: "bg-colorth",
          divider: true,
          width: "14%",
        },
        {
          text: "Receive Date",
          value: "receive_date",
          class: "bg-colorth",
          divider: true,
          width: "104px",
        },
        {
          text: "Deadline Date",
          value: "enddate",
          class: "bg-colorth",
          divider: true,
          width: "104px",
        },
        {
          text: "Internal Date",
          value: "internaldate",
          class: "bg-colorth",
          divider: true,
          width: "104px",
        },
        {
          text: "Title",
          value: "title",
          class: "bg-colorth",
          divider: true,
          width: "13%",
        },
        {
          text: "Remark",
          value: "remark",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "",
          value: "actions",
          width: "15%",
          align: "left",
          divider: true,
        },
        {
          text: "",
          value: "actions",
          align: "start",
          class: "bg-colorth",
          divider: true,
          width: "150px",
        },
      ],
      dialogAdd: false,
      pageSize: 3,
      pageSizes: [3, 6, 9],
      pageCount: 0,
      itemsPerPage: 100,
      load_bg: false,
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      showprint: "display:none;",
      print_data: {},
      previewimageedit: null,
      master_status: 0,
      patent_status_list: [
        {
          patent_status_name: "Nil (Unrecognised Status)",
          patent_status_id: 1,
        },
        { patent_status_name: "Pending", patent_status_id: 2 },
        { patent_status_name: "Registered", patent_status_id: 3 },
        { patent_status_name: "Renewal Pending", patent_status_id: 5 },
        { patent_status_name: "Closed", patent_status_id: 6 },
      ],
    };
  },
  methods: {
    formatDateToDDMMYYYY(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    // แปลงค่า pagination จาก API ให้เป็น Number
    applyPagination(pagination) {
      this.totalItems = Number(pagination.totalItems) || 0;
      this.page = Number(pagination.currentPage) || 1;
      this.itemsPerPage = Number(pagination.itemsPerPage) || this.itemsPerPage;
      this.pageCount = Number(pagination.totalPages) || 0;
    },
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      try {
        const result = await api.getMasterPTSearchPagination(
          1,
          this.itemsPerPage,
          "masterpt_id",
          "ASC",
          this.search_pt,
          this.master_status,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.applyPagination(result.data.pagination);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      var sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "ASC";
      } else {
        if (options.sortBy[0]) {
          sortDesc = "DESC";
        } else {
          sortDesc = "ASC";
        }
      }
      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }
      try {
        const result = await api.getMasterPTSearchPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          this.search_pt,
          this.master_status,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.applyPagination(result.data.pagination);
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },


    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      try {
        const result = await api.getMasterPTSearchPagination(
          pageNumber,
          this.itemsPerPage,
          "masterpt_id",
          "ASC",
          this.search_pt,
          this.master_status,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.applyPagination(result.data.pagination);
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },


    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.options.sortBy = [];
      this.options.sortDesc = [];
      this.tableLoading = true;

      if (
        !this.master_status ||
        this.master_status == "" ||
        this.master_status == "null"
      ) {
        this.master_status = 0;
      }

      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "next_annuity_date",
        sortDesc: "ASC",
        search_pt: this.search_pt,
        master_status: this.master_status,
        searchdatefrom: this.searchdatefromPicker,
        searchdateto: this.searchdatetoPicker,
      };
      try {
        const result = await api.getMasterPTSearchPagination(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortDesc,
          s_data.search_pt,
          s_data.master_status,
          s_data.searchdatefrom,
          s_data.searchdateto
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.applyPagination(result.data.pagination);
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async openPrintAppNo(item) {
      this.$showLoader();
      this.print_data = {};
      this.previewimageedit = null;
      const res_pt = await api.printPT(item.masterpt_id);
      this.print_data = res_pt.data[0];
      console.log(this.print_data);

      var dataAdd = {
        user_id: localStorage.getItem(server.USER_ID),
        log_in_out_id: localStorage.getItem(server.LOGIN_ID),
        action: "Export",
        table_name: "masterpt",
        table_id: item.masterpt_id,
        date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };

      await api.addTransectionLog(dataAdd);

      var dataEditLog = {
        last_update: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };
      await api.updateLogInOutLog(
        localStorage.getItem(server.LOGIN_ID),
        dataEditLog
      );

      setTimeout(async () => {
        await this.exportToPDF();
        this.$hideLoader();
      }, "2000");
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    editItemtimeline(item) {
      const url = `/appointment-patent-edit/${item.appointment_id}`; // หรือใส่ query ?file_no=xxx
      window.open(url, "_blank"); // เปิดหน้าใหม่
    },
    async openeditTableAppointment(appointment_id) {
      window.open(`/appointment-patent-edit/${appointment_id}`);
    },
    async loaddataLimit200() {
      // this.$showLoader();
      var tmp = [];
      const result = await api.getAllMasterPTLimit200();
      tmp = result.data;
      this.mDataArray = tmp;
    },
    async loaddata() {
      // this.$showLoader();
      this.load_bg = true;
      var tmp = [];
      const result = await api.getAllMasterPT();
      tmp = result.data;
      this.mDataArray = this.mDataArray.concat(tmp);
      this.load_bg = false;
    },
    async openeditItem(masterpt_id) {
      // this.$router.push(`/master-patent-edit/${masterpt_id}`);
      window.open(`/master-patent-edit-new/${masterpt_id}`);
    },
    async openeAppoinmentList(file_no) {
      const result = await api.getfile_noPT(file_no);
      console.log(result.data);
      if (result.data) {
        this.mDataArraypopup = result.data;
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Show data ",
          "Data not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.dialogShow = true;
      this.ShowfileNO = file_no;
    },
    async loadTimeline(masterpt_id, file_no) {
      this.showtimelineData = [];

      this.ShowfileNO = file_no;
      this.$showLoader();
      const result = await api.gettimelinemasterpt({
        masterpt_id: masterpt_id,
      });
      if (result.data.length > 0) {
        result.data.forEach((x, i) => {
          const isAnnuity = (x.documenttype_code || "").includes(
            "Annuity Fees"
          );

          if (isAnnuity) {
            x.show_date = `Last Annuity Payment - ${x.last_annuity} (Year)`;
            x.date_sort = x.last_annuity;
          } else if (x.documenttype_code === "New Filing") {
            x.show_date = `Application Date - ${x.application_date}`;
            x.date_sort = x.application_date;
          } else {
            x.show_date = `Submitted Date - ${x.submit_date}`;
            x.date_sort = x.submit_date;
          }

          this.showtimelineData.push(x);

          // parse JSON ก่อน แล้วเช็กว่ามีข้อมูลจริง
          let changeData = Array.isArray(x.change_master_record_data_All)
            ? x.change_master_record_data_All
            : [];

          if (changeData.length > 0) {
            x.documenttype_code =
              changeData.map((item) => item.field_name).join(" / ") || "";
          }
          this.showtimelineData.sort((a, b) => {
            const aIsAnnuity = (a.documenttype_code || "").includes(
              "Annuity Fees"
            );
            const bIsAnnuity = (b.documenttype_code || "").includes(
              "Annuity Fees"
            );

            // กลุ่ม if มาก่อน else
            if (aIsAnnuity && !bIsAnnuity) return -1;
            if (!aIsAnnuity && bIsAnnuity) return 1;

            // ถ้าอยู่ในกลุ่มเดียวกัน
            if (aIsAnnuity) {
              // เรียงตามตัวเลขมากไปน้อย
              return Number(b.date_sort) - Number(a.date_sort);
            } else {
              // แปลงวันที่ dd/mm/yyyy เป็น Date object แล้วเรียงมากไปน้อย
              const parseDate = (d) => {
                if (!d || typeof d !== "string") return new Date(0); // ถ้า null, undefined, หรือไม่ใช่ string ให้เป็นวันที่ต่ำสุด
                const parts = d.split("/");
                if (parts.length !== 3) return new Date(0); // ถ้ารูปแบบไม่ถูกต้อง
                const [day, month, year] = parts.map(Number);
                return new Date(year, month - 1, day);
              };
              return parseDate(b.date_sort) - parseDate(a.date_sort);
            }
          });
          // this.showtimelineData
        });
        if (
          !this.showtimelineData[0].documenttype_code &&
          this.showtimelineData.length == 1
        ) {
          this.showtimelineData = [];
        }
        // result.data.forEach((x, i) => {
        //   this.timelineData.push(x);
        //   if (JSON.parse(x.change_master_record_data_All).length > 0) {
        //     x.documenttype_code = "";
        //     x.documenttype_code =
        //       JSON.parse(x.change_master_record_data_All)
        //         ?.map((item) => item.field_name)
        //         .join(" / ") || "";
        //   }
        // });

        this.$hideLoader();
        this.dialogtimeline = true;
      } else {
        this.$hideLoader();
        Swal.fire({
          icon: "warning",
          title: "ไม่มีข้อมูล",
          text: "ไม่มีข้อมูล Patent Docket",
          showConfirmButton: false, // ❌ ไม่แสดงปุ่ม OK
          timer: 1000, // ⏱ แสดง 2 วินาทีแล้วปิดเอง
          timerProgressBar: true, // แถบเวลานับถอยหลัง (optional)
        });
        return;
      }
    },
    async openeAppoinmentOperation(file_no) {
      this.$router.push(`/appointment-patent-new/${file_no}`);
    },
    async openeAppoinmentOperationforClosed(file_no, masterpt_id) {
      this.dataupdatestatusmasterpt_id = masterpt_id;
      this.dialogAppoinmentOperationforClosed = true;
    },
    async AppoinmentOperationforClosedconfirmstatus() {
      //status 2= Pending
      this.$showLoader();
      const result = await api.updateMasterPt(
        this.dataupdatestatusmasterpt_id,
        { status: 2 }
      );
      if (result.status == 200 || result.status == 201) {
        await this.onSearchPagination();
        this.dialogAppoinmentOperationforClosed = false;
        this.$store.state.global_dialog = true;
        this.$hideLoader();
        this.setupAlertDialog(
          true,
          "Success",
          "Update Status success",
          "text-h5 green--text text-center"
        );
        return;
      } else {
        this.dialogAppoinmentOperationforClosed = false;
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Update Status Failed",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async closedialogShow() {
      this.dialogShow = false;
    },
    async onSearch() {
      if (!this.master_status) {
        this.master_status = 0;
      }
      if (this.search_pt.trim() == "" && this.master_status == 0) {
        this.$showLoader();
        await this.loaddataLimit200();
        this.$hideLoader();
      } else {
        this.$showLoader();
        const result = await api.getMasterPTSearch({
          params: {
            search_pt: this.search_pt.trim(),
            master_status: Number(this.master_status),
          },
        });
        this.mDataArray = result.data;
        this.$hideLoader();
      }
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
